import { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

import routes from "routes";
import footerRoutes from "footer.routes";

import bgImage from "assets/images/bg-about-us.jpg";

const contactInfo = [
  {
    icon: "location_on",
    title: "School Address",
    details: ["6521 Nicoz Diamond Zimre Park", "Harare, Zimbabwe"],
  },
  {
    icon: "phone",
    title: "Phone Numbers",
    details: ["+263 772 490 478", "+263 772 703 215"],
  },
  {
    icon: "email",
    title: "Email Address",
    details: ["info@rosps.co.zw", "admissions@rosps.co.zw"],
  },
  {
    icon: "schedule",
    title: "Office Hours",
    details: ["Monday - Friday: 7:30 AM - 4:30 PM", "Saturday: 8:00 AM - 12:00 PM"],
  },
];

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you for your message! We will get back to you soon.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/admissions",
          label: "Enroll Now",
          color: "success",
        }}
        transparent
        light
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Contact Us
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              We&apos;d love to hear from you - Get in touch with us today
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {/* Contact Info & Form */}
        <MKBox component="section" py={6}>
          <Container>
            <Grid container spacing={4}>
              {/* Contact Information */}
              <Grid item xs={12} lg={5}>
                <MKTypography variant="h3" mb={3}>
                  Get in Touch
                </MKTypography>
                <MKTypography variant="body1" color="text" mb={4}>
                  Have questions about admissions, academics, or anything else? 
                  We&apos;re here to help. Reach out to us using any of the methods below.
                </MKTypography>
                {contactInfo.map((info, index) => (
                  <MKBox display="flex" alignItems="flex-start" mb={3} key={index}>
                    <MKBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="3rem"
                      height="3rem"
                      borderRadius="lg"
                      sx={{ backgroundColor: "#006747", flexShrink: 0, mr: 2 }}
                    >
                      <Icon sx={{ color: "#d32f2f" }}>{info.icon}</Icon>
                    </MKBox>
                    <MKBox>
                      <MKTypography variant="h6" mb={0.5}>
                        {info.title}
                      </MKTypography>
                      {info.details.map((detail, idx) => (
                        <MKTypography variant="body2" color="text" key={idx}>
                          {detail}
                        </MKTypography>
                      ))}
                    </MKBox>
                  </MKBox>
                ))}
              </Grid>

              {/* Contact Form */}
              <Grid item xs={12} lg={7}>
                <MKBox
                  p={4}
                  borderRadius="xl"
                  sx={{
                    backgroundColor: "#f8f9fa",
                    boxShadow: ({ boxShadows: { md } }) => md,
                  }}
                >
                  <MKTypography variant="h4" mb={3}>
                    Send Us a Message
                  </MKTypography>
                  <MKBox component="form" onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          label="Full Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          type="email"
                          label="Email Address"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          label="Phone Number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          label="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MKInput
                          variant="standard"
                          label="Your Message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          multiline
                          rows={5}
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MKButton
                          type="submit"
                          variant="gradient"
                          color="success"
                          size="large"
                          fullWidth
                        >
                          Send Message
                        </MKButton>
                      </Grid>
                    </Grid>
                  </MKBox>
                </MKBox>
              </Grid>
            </Grid>
          </Container>
        </MKBox>

        {/* Google Map */}
        <MKBox component="section" py={6} sx={{ backgroundColor: "#f8f9fa" }}>
          <Container>
            <Grid container justifyContent="center" sx={{ textAlign: "center", mb: 4 }}>
              <Grid item xs={12} md={8}>
                <MKTypography variant="h3" mb={1}>
                  Find Us
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  Visit our campus and see our facilities firsthand.
                </MKTypography>
              </Grid>
            </Grid>
            <MKBox
              sx={{
                borderRadius: "xl",
                overflow: "hidden",
                boxShadow: ({ boxShadows: { lg } }) => lg,
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3798.2844444444445!2d30.9844444!3d-17.8333333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1931bb7c7c7c7c7c%3A0x7c7c7c7c7c7c7c7c!2s6521%20Nicoz%20Diamond%20Zimre%20Park!5e0!3m2!1sen!2szw!4v1704300000000!5m2!1sen!2szw"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="School Location"
              />
            </MKBox>
          </Container>
        </MKBox>

        {/* Quick Contact CTA */}
        <MKBox
          component="section"
          py={6}
          sx={{
            background: "linear-gradient(135deg, #006747 0%, #004d35 100%)",
            borderRadius: "xl",
            mx: { xs: 1, lg: 3 },
            my: 4,
          }}
        >
          <Container>
            <Grid container spacing={4} alignItems="center" justifyContent="center">
              <Grid item xs={12} md={4} textAlign="center">
                <Icon sx={{ color: "#d32f2f", fontSize: "3rem", mb: 1 }}>phone</Icon>
                <MKTypography variant="h5" color="white" mb={1}>
                  Call Us
                </MKTypography>
                <MKTypography variant="body1" color="white" opacity={0.9}>
                  +263 772 490 478
                </MKTypography>
              </Grid>
              <Grid item xs={12} md={4} textAlign="center">
                <Icon sx={{ color: "#d32f2f", fontSize: "3rem", mb: 1 }}>email</Icon>
                <MKTypography variant="h5" color="white" mb={1}>
                  Email Us
                </MKTypography>
                <MKTypography variant="body1" color="white" opacity={0.9}>
                  info@rosps.co.zw
                </MKTypography>
              </Grid>
              <Grid item xs={12} md={4} textAlign="center">
                <Icon sx={{ color: "#d32f2f", fontSize: "3rem", mb: 1 }}>location_on</Icon>
                <MKTypography variant="h5" color="white" mb={1}>
                  Visit Us
                </MKTypography>
                <MKTypography variant="body1" color="white" opacity={0.9}>
                  6521 Nicoz Diamond Zimre Park
                </MKTypography>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Contact;
